import { TouchableOpacity } from 'react-native'
import React from 'react'
import { PrimaryText } from '@components/Common/PrimaryText/PrimaryText'
import { useNavigate } from 'react-router'
import { PrimaryButtonProps } from '@Interfaces/Component/ButtonInterfaces'
import { primaryButtonStyles } from '@components/Buttons/buttons.styles'

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  title,
  onPress,
  to,
  variant,
  disabled,
  style,
  titleStyle,
  icon,
  rightIcon,
  fontSize = 16,
  fontWeight = 900,
  ignoreScaling = false,
}) => {
  const navigate = useNavigate()

  return (
    <TouchableOpacity
      onPress={() => {
        if (disabled) return
        onPress?.()
        if (to) navigate(to)
      }}
      style={[
        primaryButtonStyles.button,
        variant === 'outlined'
          ? primaryButtonStyles.outlined
          : variant === 'link'
            ? primaryButtonStyles.link
            : primaryButtonStyles.contained,
        style,
        disabled && { opacity: 0.5 },
      ]}
      disabled={disabled}
    >
      {icon}
      <PrimaryText
        fontSize={fontSize}
        fontWeight={fontWeight}
        style={[
          variant === 'outlined'
            ? primaryButtonStyles.outlinedTitle
            : variant === 'link'
              ? primaryButtonStyles.linkTitle
              : primaryButtonStyles.containedTitle,
          titleStyle,
        ]}
        ignoreScaling={ignoreScaling}
      >
        {title}
      </PrimaryText>

      {rightIcon}
    </TouchableOpacity>
  )
}

export default PrimaryButton
